import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule, ViewportScroller } from '@angular/common';

import { User } from '@app/models';
import { GpsV2Service, UserService, UtilsV2Service } from '@app/services';
import { Router } from '@angular/router';
import { DEVELOPER_ROUTES } from '@app/constants/paths/developer/developer.const';

import { DashboardV2NoInvestorsComponent } from './dashboard-v2-no-investors/dashboard-v2-no-investors.component';
import { DashboardV2InvestorsComponent } from './dashboard-v2-investors/dashboard-v2-investors.component';
import { UserStatusModel } from '@interfaces/app';

@Component({
  selector: 'mnf-dashboard-v2',
  standalone: true,
  imports: [CommonModule ,DashboardV2NoInvestorsComponent, DashboardV2InvestorsComponent],
  templateUrl: './dashboard-v2.component.html',
  styleUrl: './dashboard-v2.component.scss',
  encapsulation: ViewEncapsulation.Emulated
})
export class DashboardV2Component implements OnInit {

  user: User;

  actualStatusUser: UserStatusModel;

  dateNow: Date = new Date();

  constructor(
    private readonly userServ: UserService,
    private readonly gpsServ: GpsV2Service,
    private readonly router: Router,
    private readonly utilsV2Serv: UtilsV2Service
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.initGpsAndLoadUser();
  }

  formatName(name: string): string {
    return name?.toLowerCase()?.replace(/\b\w/g, (c) => c?.toUpperCase());
  }

  async initGpsAndLoadUser(): Promise<void> {
    const gps = await this.gpsServ.getCoordinatesFromLocalStorage();

    if (gps) {
      this.loadUserData();
    } else {
      this.gpsServ.getGpsCoordinates({ maximumRetries: 3 }).subscribe({
        next: (coords) => {
          this.gpsServ.saveCoordinatesInStorage(
            coords.latitude,
            coords.longitude,
            coords.accuracy
          );
          this.loadUserData();
        },
        error: (err) => {
          console.error('No se pudo obtener ubicación:', err);
        }
      });
    }
  }

  private loadUserData(): void {
    this.userServ.getUserInf(true).subscribe((infoUser: User) => {
      if (infoUser.type === 'd' && window.location.pathname.includes('inicio')) {
        this.router.navigate([DEVELOPER_ROUTES.ROUTE_DEVELOPER]);
        return;
      }
      this.user = infoUser;
      this.actualStatusUser = this.utilsV2Serv.defineDashboardToShow(infoUser);
    });
  }

}
